/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

import {spacingPx, surfaceVar, text} from 'ui';

/** Полотно страницы: тёмный фон дизайн-системы во всю высоту окна. */
export const Page = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
  color: surfaceVar('onSurface'),
}));

/**
 * Колонка содержимого. Уже, чем в самом отчёте (там 1180): здесь список
 * коротких строк, и широкая колонка растянула бы их в пустоту.
 */
export const Content = styled(Box)({
  maxWidth: 760,
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingLeft: spacingPx('l'),
  paddingRight: spacingPx('l'),
  paddingTop: spacingPx('xl') * 2,
  paddingBottom: spacingPx('xl'),
});

export const PageTitle = styled(Box)({
  ...text('heading.xl'),
  color: surfaceVar('onSurface'),
  margin: 0,
});

/** Подпись под заголовком: что это за список и откуда он берётся. */
export const PageLead = styled(Box)({
  ...text('body.l'),
  color: surfaceVar('onSurfaceLight'),
  maxWidth: 560,
});
